import { Modal } from '@sqs/rosetta-elements';
import React, { useState } from 'react';
import { UserChangeRoleModal } from '../components/Users/UserChangeRoleModal';
import { UserRemoveUserFromOrgModal } from '../components/Users/UserRemoveUserFromOrgModal';
import { OrgUser } from '../models/SqspUser';

interface UseOrgUserActionsProps {
  onClose?: () => void;
  refresh?: () => void;
}

export const useOrgUserActions = ({ onClose, refresh }: UseOrgUserActionsProps = {}) => {
  const [showRemoveUserFromOrgModal, setShowRemoveUserFromOrgModal] = useState<OrgUser>();
  const [showChangeRoleModal, setShowChangeRoleModal] = useState<number>(0);

  const closeAllModals = () => {
    if (onClose) {
      onClose();
    }
    setShowRemoveUserFromOrgModal(undefined);
    setShowChangeRoleModal(0);
  };

  return {
    showRemoveUserFromOrgModal: (orgUser: OrgUser) => setShowRemoveUserFromOrgModal(orgUser),
    showChangeRoleModal: (id: number) => setShowChangeRoleModal(id || 0),
    closeModals: closeAllModals,
    renderOrgActionModals: () => (
      <Modal.Transition>
        {showRemoveUserFromOrgModal && (
          <UserRemoveUserFromOrgModal orgUser={showRemoveUserFromOrgModal} closeModal={closeAllModals} />
        )}

        {showChangeRoleModal > 0 && (
          <UserChangeRoleModal orgUserId={showChangeRoleModal} closeModal={closeAllModals} refresh={refresh} />
        )}
      </Modal.Transition>
    ),
  };
};
